import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const TrioUniPlusDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Cazane industriale pe combustibil solid <span className={styles.highlight}>Trio Uni Plus</span></p>
      <p className={styles.text}>
        Cazanul pe combustibili solizi modelul  TRIO UNI Plus 80-600 kW destinat încălzirii caselor, spațiilor industriale și a altor încăperi înzestrate cu sistem de încălzire centralizata. Pregătirea și furnizarea de căldură pentru necesitățile tehnologice care utilizează drept combustibil lemn de foc, deșeuri lemnoase, cărbune, brichete din rumeguș, coajă de floarea soarelui, semințe, paie, stuf și turba, ruf etc.
      </p>
      <p className={styles.text}>
        Construcția cazanului permite cea mai eficienta utilizare a căldurii generate de arderea diferitelor tipuri de combustibili solizi cu un conținut scăzut de calorii. Timpul  de ardere în urma unei singure încărcări al combustibilului depinde în mod direct de calitatea acestuia și pierderii de căldură a imobilului încălzit.
      </p>
      <h1 className={styles.title}>Caracteristici</h1>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-triangle-exclamation" />
          <p>
            Exploatarea cazanului este posibila numai în modul de încărcare manuala a combustibililor solizi.
            <p className={styles.text}>
              Prin retehnologizarea corespunzătoare a cazanului, conform recomandărilor din manual,este posibila transferarea acestuia în mod automat de alimentare cu combustibil și anume pe peleți.
            </p>
          </p>
        </div>
      </div>
      <h1 className={styles.title}>Caracteristici</h1>
      <p className={styles.text}>
        Grosimea carcasei din oțel a cazanului și suprafeței schimbătorului de căldură este de 6 мм. Cazanele cu ardere completa  TRIO UNI Plus 80-600kW  au  o izolare calitativă și bine gândită a carcasei cazanului.
      </p>
      <p className={styles.text}>
        Reglarea puterii cazanului TRIO UNI Plus se face cu ajutorul ventilatorului, alimentând necesarul de aer în camera de ardere prin duzele de aer și pe sub grătarul de fonta (reglanduse automat).
      </p>
      <p className={styles.text}>
        Partea de convecție a cazanului este formată din doua camere  (80-97 кW) sau patru camere (150-500 кW) verticale ale schimbătorului de căldură. Schimbătorul de căldură este poziționat după camera de ardere, în partea din spate a cazanului.
      </p>
      <p className={styles.text}>
        La cazanele  TRIO UNI Plus gura de alimentare a combustibilului este amplasată sub unghiul de 45 grade,ce face alimentarea mai ușoară cu combustibili vărsați.
      </p>
      <p className={styles.text}>
        În partea inferioară a cazanului se afla un grătar răcitor cu apa.Pentru a preveni posibile fisuri și scurgeri ,acestea sunt realizate din țevi monolit (fără sudura).
      </p>
      <p className={styles.text}>
        Datorită răcirii constante a apei circulante prin țevi, grătarul nu se supraîncălzește și servește ca suprafață suplimentară de schimb de căldură.
      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-triangle-exclamation" />
          <p>
            Exploatarea cazanului este posibila numai în modul de încărcare manuala a combustibililor solizi.
            <p className={styles.text}>
              Comenzile personalizate ale cazanelor TRIO UNI Plus (putere de la 80 кW) au posibilitatea instalării unei uși de revizie pe partea laterala a cazanului.            </p>
          </p>
        </div>
      </div>
      <p className={styles.text}>
        Aceasta oferă acces pentru curățarea rafturilor verticale ale schimbătorului de căldură. Ușița de revizie este zidită în beton anti-incendiu (material refractar), care asigura o izolare termica sigura și protecție împotriva distrugerii termice a metalului ușii. Pentru a menține izolarea ermetică a schimbătorului de căldură, au fost instalate placi reglabile și o placă de presare în trei puncte.
      </p>
      <p className={styles.text}>
        Gura de evacuare se afla în spatele cazanului și are forma cilindrica.
      </p>
      <p className={styles.text}>
        Versatilitate, eficiența, ușurința de exploatare a acestor cazane, cu un nivel excelent de furnizare de căldura la un consum minim de combustibili, face ca nivelul popularității cazanelor Altep, sa fie atât de mare în rândul majorității clienților de centrale termice.
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th>97 kW</th>
              <th>150 kW</th>
              <th>200 kW</th>
              <th>250 kW</th>
              <th>300 kW</th>
              <th>400 kW</th>
              <th>500 kW</th>
              <th>600 kW</th>
              <th>700 kW</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Suprafața schimbătorului de căldură</td>
              <td>m²</td>
              <td>8,0</td>
              <td>10,0</td>
              <td>15,0</td>
              <td>18,5</td>
              <td>27,0</td>
              <td>31,0</td>
              <td>37,0</td>
              <td>45,0</td>
              <td>52,0</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="11">Dimensiuni camera de ardere</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Adâncime</td>
              <td>mm</td>
              <td>750</td>
              <td>850</td>
              <td>900</td>
              <td>1000</td>
              <td>1150</td>
              <td>1150</td>
              <td>1350</td>
              <td>1500</td>
              <td>1500</td>
            </tr>
            <tr>
              <td>Volum</td>
              <td>dm³</td>
              <td>430</td>
              <td>570</td>
              <td>790</td>
              <td>1100</td>
              <td>1480</td>
              <td>1680</td>
              <td>2060</td>
              <td>3050</td>
              <td>3050</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>l</td>
              <td>265</td>
              <td>325</td>
              <td>455</td>
              <td>545</td>
              <td>750</td>
              <td>840</td>
              <td>970</td>
              <td>1200</td>
              <td>1400</td>
            </tr>
            <tr>
              <td>Greutate cazan fără apă</td>
              <td>kg</td>
              <td>950</td>
              <td>1060</td>
              <td>1540</td>
              <td>1990</td>
              <td>2610</td>
              <td>2900</td>
              <td>3350</td>
              <td>4260</td>
              <td>4600</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse</td>
              <td>°C</td>
              <td colSpan="9">100-180</td>
            </tr>
            <tr>
              <td>Temperatura min. recomandată</td>
              <td>°C</td>
              <td colSpan="9">58</td>
            </tr>
            <tr>
              <td>Temperatura max. permisă a apei din cazan</td>
              <td>°C</td>
              <td colSpan="9">90</td>
            </tr>
            <tr>
              <td>Presiunea nominală a apei</td>
              <td>mPa</td>
              <td colSpan="9">0,20</td>
            </tr>
            <tr>
              <td>Consum energie electrică, max</td>
              <td>W</td>
              <td>170</td>
              <td>170</td>
              <td>205</td>
              <td>205</td>
              <td>315</td>
              <td>485</td>
              <td>805</td>
              <td>1110</td>
              <td>1110</td>
            </tr>
            <tr>
              <td>Diametrul ext al gurii de evacuare</td>
              <td>mm</td>
              <td>248</td>
              <td>298</td>
              <td>348</td>
              <td>398</td>
              <td>448</td>
              <td>498</td>
              <td>548</td>
              <td>548</td>
              <td>548</td>
            </tr>
            <tr>
              <td>Diametrul țevilor conexiune rețea apa</td>
              <td>mm</td>
              <td>65(FL)</td>
              <td>65(FL)</td>
              <td>80(FL)</td>
              <td>100(FL)</td>
              <td>100(FL)</td>
              <td>100(FL)</td>
              <td>125(FL)</td>
              <td>125(FL)</td>
              <td>125(FL)</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="11">Parametri recomandați burlan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>452</td>
              <td>660</td>
              <td>660</td>
              <td>908</td>
              <td>1194</td>
              <td>1520</td>
              <td>1885</td>
              <td>2290</td>
              <td>2290</td>
            </tr>
            <tr>
              <td>Diametrul intern</td>
              <td>mm</td>
              <td>250</td>
              <td>300</td>
              <td>300</td>
              <td>350</td>
              <td>400</td>
              <td>450</td>
              <td>500</td>
              <td>550</td>
              <td>550</td>
            </tr>
            <tr>
              <td>Înălțime (min. recomandată)</td>
              <td>m</td>
              <td>7</td>
              <td>7</td>
              <td>7</td>
              <td>9</td>
              <td>10</td>
              <td>12</td>
              <td>13</td>
              <td>14</td>
              <td>16</td>
            </tr>
            <tr>
              <td>Diametru țevii de sub siguranțele supapei</td>
              <td>mm</td>
              <td>20</td>
              <td>25</td>
              <td>25</td>
              <td>50(FL)</td>
              <td>50(FL)</td>
              <td>50(FL)</td>
              <td>50(FL)</td>
              <td>2×50(FL)</td>
              <td>2×50(FL)</td>
            </tr>
            <tr>
              <td>Diametrul țevii de scurgere a apei din cazan</td>
              <td>mm</td>
              <td>20</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
              <td>25</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const TrioUniPlusDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [840, 940, 1040, 1160, 1320, 1370, 1420, 1670, 1790] },
    { param: "H", unit: "mm", values: [1540, 1560, 1800, 1900, 1900, 2000, 2010, 2160, 1970] },
    { param: "H1", unit: "mm", values: [1320, 1340, 1540, 1640, 1640, 1740, 1740, 1840, 1840] },
    { param: "H2", unit: "mm", values: [1080, 1075, 1265, 1315, 1290, 1365, 1340, 1415, 1415] },
    { param: "H3", unit: "mm", values: [285, 285, 355, 355, 355, 355, 355, 355, 355] },
    { param: "L", unit: "mm", values: [1700, 1900, 2250, 2350, 2660, 2740, 3200, 3350, 3590] },
    { param: "L1", unit: "mm", values: [1370, 1530, 1880, 1980, 2285, 2365, 2725, 2880, 3070] }
  ]


  const headers = ["Parametri", "U.M.", "97 kW", "150 kW", "200 kW", "250 kW", "300 kW", "400 kW", "500 kW", "600 kW", "700 kW"]

  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/TrioUniPlusSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};